import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'shared_DEPRECATED/hooks';

import { TranscriptInsightsStructureResponse } from 'features/sessions/config/types';

export const useSessionTranscriptCustomStructureQuery = (
  isEnabled: boolean,
  insightStructureCode: string
) => {
  const { request } = useQueryHTTPRequest();

  return useQuery<TranscriptInsightsStructureResponse, unknown, string>(
    [queryKeys.coachSessionTranscriptCustomStructure, insightStructureCode],
    () =>
      request({
        url: `/api/coach/transcript-insights-structure/${insightStructureCode}`,
      }),
    {
      select: (data) => data.structure,
      useErrorBoundary: false,
      retry: 0,
      enabled: isEnabled,
    }
  );
};
